import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Injector,
  Input,
  OnInit,
} from '@angular/core';
import { DropdownControlComponent } from '../dropdown-control/dropdown-control.component';
import { TranslateService } from '@ngx-translate/core';
import { MakeProvider } from '@anecdotes/design-system/form-controls';

@Component({
  selector: 'app-color-picker',
  templateUrl: './color-picker.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MakeProvider(ColorPickerComponent)],
  standalone: false,
})
export class ColorPickerComponent extends DropdownControlComponent implements OnInit {
  @Input()
  optionIconSelector: (option: any) => string;

  get selectedOptionIcon(): string {
    return this.optionIconSelector(this.value);
  }

  constructor(
    injector: Injector,
    translate: TranslateService,
    hostElementRef: ElementRef<HTMLElement>,
    cd: ChangeDetectorRef,
  ) {
    super(injector, translate, hostElementRef, cd);
    this.dropdownPosition = [
      {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
        offsetY: 2,
      },
    ];
  }

  isSelected(value: string): boolean {
    return value === this.value;
  }
}
